<app-section #parentSection
             *ngIf="sectionVisible"
             [customClass]="'calculation-cache-section'"
             [key]="key"
             [sectionRef]="section"
             [formGroup]="formGroup"
             [formConfig]="formConfig">

    <ng-template #section>

        <ng-container *ngIf="isNext; else calculationsCacheSection">

            <div class="calculation-cache-section__content">
                <div class="calculation-cache-section__title">
                    <img class="calculation-cache-section__title__icon" [src]="iconsDirectoryPath + '/car-calculations.svg'">
                    <span class="calculation-cache-section__title__text">
                        {{title}}
                    </span>
                </div>

                <div class="calculation-cache-section__details">
                    <div class="calculation-cache-section__details__value">
                        {{ lastCalculation.registrationNumber }}
                    </div>

                    <div class="calculation-cache-section__details__value">
                        {{ lastCalculation.vehicle }}
                    </div>

                    <div class="calculation-cache-section__details__value">
                        {{ lastCalculation.creationDate | date:'dd-MM-yyyy HH:mm'}}
                    </div>
                </div>

                <div class="calculation-cache-section__button">
                    <button (click)="openCalculation(lastCalculation)"
                            class="btn btn--secondary">
                        {{ (CALCULATIONS_CACHE_SECTION + '.buttonOpen') | translate}}
                    </button>
                </div>
            </div>

        </ng-container>

        <ng-template #calculationsCacheSection>
            <div class="calculation-cache-section__header">
                <div class="calculation-cache-section__header--title"> {{title}} </div>
    <!--            <div class="calculation-cache-section__header&#45;&#45;remove-item">-->
    <!--                <mat-icon (click)="removeCalculations()">close</mat-icon>-->
    <!--            </div>-->
            </div>

            <div *ngFor="let calculation of calculations" class="calculation-cache-section__row">
                <div class="calculation-cache-section__row--car-icon">
                    <img [src]="iconsDirectoryPath + '/oc.svg'">
                </div>

                <div class="row-calc-info">
                    <div class="row-calc-info__item"
                         *ngIf="calculation.registrationNumber && calculation.registrationNumber !== 'BRAK'">
                        {{ calculation.registrationNumber }}
                    </div>
                    <div class="row-calc-info__item"> {{ calculation.vehicle }}</div>
                    <div class="row-calc-info__item"> {{ calculation.creationDate | date:'dd-MM-yyyy HH:mm'}}</div>
                </div>

                <button (click)="openCalculation(calculation)" class="btn btn--secondary">
                    {{ (CALCULATIONS_CACHE_SECTION + '.buttonOpen') | translate}}
                </button>
            </div>
        </ng-template>

    </ng-template>
</app-section>
